import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Header from './components/Header';
import Footer from './components/Footer';
import About from "./pages/About";
function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-[#f8fafc] text-slate-900 font-sans selection:bg-indigo-500 selection:text-white relative overflow-x-hidden">
        
        {/* Soft Background Orbs for Premium SaaS Feel */}
        <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
          {/* Top Left Indigo Orb */}
          <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-indigo-300 mix-blend-multiply filter blur-[100px] opacity-40 animate-blob"></div>
          {/* Top Right Purple Orb */}
          <div className="absolute top-[-5%] right-[-10%] w-[35%] h-[35%] rounded-full bg-purple-300 mix-blend-multiply filter blur-[100px] opacity-40 animate-blob" style={{animationDelay: "2s"}}></div>
          {/* Bottom Center Blue Orb */}
          <div className="absolute bottom-[-20%] left-[20%] w-[50%] h-[50%] rounded-full bg-sky-200 mix-blend-multiply filter blur-[100px] opacity-30 animate-blob" style={{animationDelay: "4s"}}></div>
          {/* Dotted Overlay Texture */}
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/micro-carbon.png')] opacity-[0.03]"></div>
        </div>

        <Header />
        <main className="flex-grow container mx-auto px-4 py-12 lg:py-16 relative z-10 w-full max-w-6xl">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
